import useClusterSwitchSetting, { isSwitchOn } from '../useClusterSwitchSetting'

/**
 * Single route the cluster send switch is read from and written to (`ClusterSendSettingRest`).
 * `GET` needs nothing but an authenticated caller -- the production manager who sends orders does
 * not necessarily administer the installation -- while `PUT` asks for the `SETTINGS` authority.
 */
export const FABRICATION_ORDER_CLUSTER_SEND_SETTING_ENDPOINT = 'cluster/fabricationOrderSendSetting'

/**
 * Whether the answer of the switch says it is on. Kept as a named export because it is part of this
 * hook's published surface since historia 107; the rule itself is shared with every other cluster
 * switch (`isSwitchOn`), and there is only one of it.
 *
 * @param {Object} setting Answer of the switch endpoint
 * @returns {boolean} True only when the switch is explicitly on
 */
export const isSendSettingOn = isSwitchOn

/**
 * S54/S39 (historia 107, RN1.1 + CA10): reads the switch that enables sending fabrication orders to
 * a cluster node.
 *
 * Default OFF and no request out of a cluster: both promises live in `useClusterSwitchSetting`,
 * which is where they are documented, because historia 108 added a second switch of exactly this
 * shape and the guarantees must not drift apart between the two.
 *
 * @param {boolean} inCluster Whether this installation belongs to a cluster (`frontEndConfig`)
 * @returns {boolean} Whether sending fabrication orders to a cluster node is enabled
 */
const useFabricationOrderClusterSendSetting = (inCluster) =>
  useClusterSwitchSetting(inCluster, FABRICATION_ORDER_CLUSTER_SEND_SETTING_ENDPOINT)

export default useFabricationOrderClusterSendSetting
